/**
 * Created by comoon on 2/18/16.
 */

var $ = require("jquery");

$(function () {
    $('.js-follow-nav').scrollToFixed();
    //$('.js-booking-follow').scrollToFixed({
    //    marginTop: 70,
    //    limit: function () {
    //        return $('.js-sys-footer').offset().top - 550
    //    }
    //});

    var scrollTo = function (targetSelector, container) {

        var scrollFn = function (e) {

            var href = $(this).attr("href");

            if (!href) {
                return;
            }

            var offsetTop = href === "#" ? 0 : $(href).offset().top - topMenuHeight + 1;

            e.preventDefault();

            $('html, body').stop().animate({
                scrollTop: offsetTop
            }, 300);

        }

        if( typeof container === 'undefined'  ){
            container = $('body');
        }
        container.on('click', targetSelector, scrollFn);
    };

    scrollTo(  '.js-link', $('.js-follow-nav') );
    scrollTo(  '.js-anchor', $('.quote-container') );

    var lastId,

        topMenu = $(".js-follow-nav"),
        topMenuHeight = topMenu.outerHeight() + 20,
        menuItems = topMenu.find(".item"),
        scrollItems = menuItems.map(function () {

            var item = $($(this).find(".js-link").attr("href"));
            if (item.length) {
                return item;
            }

        });


    $('.js-go-top').on('click' ,function(e){
        $('body,html').animate({scrollTop: 0}, 250);
    })

    $('.to_product_order').on('click', function (e) {
        $('a[href="#ordernote1"]').trigger('click');
        e.preventDefault();
    })
    $('.price-contain-anchor').on('click', function (e) {

        $('a[href="#product"]').trigger('click');
        e.preventDefault();
    });

    var alikeContainer = $(".alike-container");
    var quoteContainer = $(".quote-container");
    var footer = $(".js-sys-footer");

    var summary = $("#summary");

    var winScrollTop = 0;

    $(window).on('resize', function () {

        quoteContainer.removeClass("fixed").css("left", "");

        repositionQuoteContainer();
    });

    function repositionQuoteContainer() {
        var alikeOffset = alikeContainer.offset();
        var footerOffset = footer.offset();
        var quoteContainerOffset = quoteContainer.offset();
        var quoteContainerTop = footerOffset.top - alikeOffset.top - quoteContainer.height()-100;
        //console.log(123,quoteContainerOffset,quoteContainer,footerOffset)

        /*if ($(window).height() < 800) {

            return;
        }*/


        if (($(window).scrollTop() > summary.offset().top)) {

            if(quoteContainerOffset.top + quoteContainer.height() >= footerOffset.top && !winScrollTop){

                if (quoteContainer.hasClass("fixed")) {
                    quoteContainer.removeClass("fixed").css({"position": "relative", "top": quoteContainerTop, "left":""});
                    winScrollTop = $(window).scrollTop();
                }
            }else{

                if(!quoteContainer.hasClass("fixed") && !winScrollTop){
                    quoteContainer.addClass("fixed").css("left", quoteContainerOffset.left);
                }

                if (!quoteContainer.hasClass("fixed")  && $(window).scrollTop()<winScrollTop) {
                    //quoteContainer.addClass("fixed").css("left", quoteContainerOffset.left);
                    quoteContainer.addClass("fixed").css({"position": "", top: 0, "left": quoteContainerOffset.left});
                    winScrollTop = 0
                }
            }

        } else {

            if (quoteContainer.hasClass("fixed")) {

                quoteContainer.removeClass("fixed").css("left", "");
            }
        }
    }

    $(window).scroll(function () {

        repositionQuoteContainer();

        var fromTop = $(this).scrollTop() + topMenuHeight;

        var cur = scrollItems.map(function () {
            if ($(this).offset().top < fromTop)
                return this;
        });


        cur = cur[cur.length - 1];

        var id = cur && cur.length ? cur[0].id : "";

        if (!id) {

            return;
        }

        if (lastId !== id) {
            lastId = id;
            menuItems.removeClass("current").filter(function () {
                return $(this).find(".js-link." + id).length === 1
            }).addClass("current");
        }
    });
});


/** WEBPACK FOOTER **
 ** ./script/detail/nav-follow.js
 **/